import { objectSpread2 as _objectSpread2, slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useCallback, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { InternalToast } from './AidToast.js';

var toastArray = [];
var noop = function noop() {};
function resolveContainer(getContainer) {
  var container = getContainer;
  return container || document.body;
}
function show(p) {
  var props = typeof p === 'string' ? {
    content: p
  } : p;
  var timer = 0;
  var _props$afterClose = props.afterClose,
    afterClose = _props$afterClose === void 0 ? noop : _props$afterClose,
    _props$getContainer = props.getContainer,
    getContainer = _props$getContainer === void 0 ? document.body : _props$getContainer;
  var container = document.createElement('div');
  var bodyContainer = resolveContainer(getContainer);
  bodyContainer.appendChild(container);
  var state = _objectSpread2({
    duration: props.icon === 'loading' ? 0 : 2000
  }, props);
  var TempToast = function TempToast() {
    var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];
    var _afterClose = function _afterClose() {
      afterClose();
      setVisible(false);
    };
    var destroy = useCallback(function () {
      setVisible(false);
    }, []);
    useEffect(function () {
      _clear();
      timer = window.setTimeout(function () {
        toastArray.push(_afterClose);
      });
      return function () {
        window.clearTimeout(timer);
      };
    }, []);
    useEffect(function () {
      if (state.duration !== 0 && 'duration' in state) {
        timer = window.setTimeout(destroy, state.duration);
      }
      return function () {
        if (timer !== 0) {
          window.clearTimeout(timer);
        }
      };
    }, [destroy]);
    useEffect(function () {
      if ('duration' in state && state.duration !== 0) {
        window.clearTimeout(timer);
        timer = window.setTimeout(destroy, state.duration);
      }
    }, [state.duration]);
    return /*#__PURE__*/React.createElement(InternalToast, _objectSpread2(_objectSpread2({}, state), {}, {
      getContainer: container,
      visible: visible,
      afterClose: _afterClose
    }));
  };
  ReactDOM.render( /*#__PURE__*/React.createElement(TempToast, null), container);
}
function _clear() {
  var fn = toastArray.pop();
  while (fn) {
    fn();
    fn = toastArray.pop();
  }
}
function clear() {
  setTimeout(_clear);
  _clear();
}

export { clear, noop, resolveContainer, show };
